"use strict";
import { useTheme } from "lib/styled-components";
import { useMemo } from "react";
import { useFormatter } from "utils/formatNumbers";
import { computeRealizedPriceImpact, getPriceImpactWarning } from "utils/prices";
export function usePriceImpact(trade) {
  const theme = useTheme();
  const { formatPercent } = useFormatter();
  return useMemo(() => {
    const marketPriceImpact = trade ? computeRealizedPriceImpact(trade) : void 0;
    const priceImpactWarning = marketPriceImpact ? getPriceImpactWarning(marketPriceImpact) : void 0;
    const warningColor = priceImpactWarning === "error" ? theme.critical : priceImpactWarning === "warning" ? theme.deprecated_accentWarning : void 0;
    return marketPriceImpact && priceImpactWarning && warningColor ? {
      priceImpactSeverity: {
        type: priceImpactWarning,
        color: warningColor
      },
      displayPercentage: () => formatPercent(marketPriceImpact)
    } : void 0;
  }, [formatPercent, theme.critical, theme.deprecated_accentWarning, trade]);
}
